import { render, staticRenderFns } from "./DataStatisticsPeriod.vue?vue&type=template&id=27a1e867"
import script from "./DataStatisticsPeriod.vue?vue&type=script&lang=js"
export * from "./DataStatisticsPeriod.vue?vue&type=script&lang=js"
import style0 from "./DataStatisticsPeriod.vue?vue&type=style&index=0&id=27a1e867&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports